import { KeenIcon } from '@/components';
import { toAbsoluteUrl } from '@/utils/Assets';
import { useSettings } from '@/providers/SettingsProvider';

const AdvancedSettingsAppearance = ({
  title
}) => {
  const { settings, storeSettings } = useSettings();
  const items = [{
    image: '28.jpg',
    logo: 'azure.svg',
    label: 'Dark',
    checked: true
  }, {
    image: '32.jpg',
    logo: 'google.svg',
    label: 'Light',
    checked: false
  }, 
  // {
  //   image: '30.jpg',
  //   logo: 'openid.svg',
  //   label: 'Sistem',
  //   checked: false
  // }
  ];
  
  const handleThemeMode = (event) => {
    const selectedTheme = event.target.value;
    storeSettings({ themeMode: selectedTheme });
  };
  
  const renderItem = (item, index) => {
    return <div key={index}>
        <label className="flex items-end border bg-no-repeat bg-cover border-gray-300 rounded-xl has-[:checked]:border-success has-[:checked]:border-3 [&_.checked]:has-[:checked]:flex h-[170px] mb-0.5" style={{
        backgroundImage: `url(${toAbsoluteUrl(`/media/images/600x400/${item.image}`)})`
      }}>
          {/* <input className="appearance-none" type="radio" name="appearance_option"  checked={settings.themeMode === 'dark'} onClick={handleThemeMode} value="2" readOnly /> */}
          <input
            className="appearance-none"
            type="radio"
            name="appearance_option"
            value={item.label.toLowerCase()} // "dark" or "light"
            checked={settings.themeMode === item.label.toLowerCase()}
            onChange={handleThemeMode}
          />
          <KeenIcon icon="check-circle" className="checked ms-5 mb-5 text-xl text-success leading-none hidden" style="solid" />
        </label>
        <span className="text-sm font-medium text-gray-900">{item.label}</span>
      </div>;
  };
  return <div className="card">
      <div className="card-header" id="advanced_settings_appearance">
        <h3 className="card-title">{title || 'Appearance'}</h3>
      </div>

      <div className="card-body lg:py-7.5">
        <div className="mb-5">
          <h3 className="text-md font-medium text-gray-900">Theme mode</h3>
          <span className="text-2sm text-gray-700">Select or customize your ui theme</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 lg:gap-7.5">
          {items.map((item, index) => {
          return renderItem(item, index);
        })}
        </div>
      </div>
    </div>;
};
export { AdvancedSettingsAppearance };